
export default function getCities(filterText) {
  filterText = filterText ? filterText.replace(' ','+') : '';

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `https://epublis.jahnet.eu/cities/?text=${filterText}`);
    xhr.send();

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        setTimeout(resolve(JSON.parse(xhr.response).sort((a, b) => {
          if (a.mesto > b.mesto) return 1;
          if (a.mesto < b.mesto) return -1;
        })), 2000);
      } else {
        reject()
      }
    };
  });
}
